import { render, staticRenderFns } from "./DeleteWarehouse.vue?vue&type=template&id=c542cc00&"
import script from "./DeleteWarehouse.vue?vue&type=script&lang=js&"
export * from "./DeleteWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports